import { Component, HostListener } from '@angular/core';
import { ProductListComponent } from '../product-list/product-list.component';

@Component({
  selector: 'app-catalogue-view',
  standalone: true,
  imports: [ProductListComponent],
  templateUrl: './catalogue-view.component.html',
  styleUrl: './catalogue-view.component.scss'
})
export class CatalogueViewComponent {
  
}
